import { Classes, Dialog, Tooltip } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { Buttons } from "modules/common/components/form";
import { formatMoney } from "modules/common/components/money/Money";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import React, { useState } from "react";
import { WorkloadSpendingOrderType } from "../models/workload-spending-order";
import styles from "./WorkloadOrderList.module.scss";

interface Project {
  id: number;
  name: string;
  order: number;
}
export const showSpending = (spending: number, hours: number) => {
  return `${formatMoney(spending)} (${hours}ч)`;
};
interface WorkloadOrderListProps {
  canDepartmentOnly: boolean;
  orders: WorkloadSpendingOrderType[];
  saveDefaultDepartmentSpending: (departmentId: string, orderId: string, defaultPlan: boolean) => Promise<boolean>;
  departments: string[];
}
export const WorkloadOrderList: React.FC<WorkloadOrderListProps> = observer((props) => {
  const { orders, saveDefaultDepartmentSpending, canDepartmentOnly, departments } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const [showDepartments, setShowDepartments] = useState(false);
  const [showSaveDepartment, setShowSaveDepartment] = useState(false);
  const [saveDefaultPlan, setSaveDefaultPlan] = useState(false);

  const [selectedDepartment, setSelectedDepartment] = useState<string>("");

  const [selectedOrder, setSelectedOrder] = useState<WorkloadSpendingOrderType>();

  const toggleShowDepartments = () => {
    setShowDepartments(!showDepartments);
  };

  const toggleShowSaveDepartment = () => {
    setSelectedDepartment("");
    setShowSaveDepartment(!showSaveDepartment);
    setSaveDefaultPlan(false);
  };
  const selectedDep = selectedOrder?.departments.find((d) => d.departmentName === selectedDepartment);

  const getDepartmentData = () => {
    if (!canDepartmentOnly || departments.length === 0) return [];

    const departmentName = departments[0];
    return orders
      .map((order) => {
        const department = order.departments.find((d) => d.departmentName === departmentName);
        if (!department) return null;

        return {
          orderId: order.orderId,
          orderName: order.orderName,
          department: department,
        };
      })
      .filter(Boolean);
  };

  const departmentData = getDepartmentData();

  return (
    <div className={styles.projectsList}>
      <Dialog
        title={`Плановые затраты по проекту ${selectedOrder?.orderName}`}
        isOpen={showDepartments}
        onClose={toggleShowDepartments}
        backdropClassName="standard"
        className={`${styles.departmentDialog} figma-dialog`}
      >
        <div className={`${Classes.DIALOG_BODY} `}>
          {selectedOrder && selectedOrder.departments.length > 0 ? (
            <div className={styles.departmentRow}>
              <div className={styles.departmentName}>Отдел</div>
              <div className={styles.departmentDefaultPlan}>Начальный План</div>
              {/* <div className={styles.departmentTotalPlan}>Всего План</div> */}
              <div className={styles.departmentTodayPlan}>Текущий План</div>
            </div>
          ) : (
            <span>Отсутствуют данные по отделам за период!</span>
          )}
          <div className={styles.departmentList}>
            {selectedOrder &&
              selectedOrder.departments.map((department, index) => (
                <div className={styles.departmentRow} key={index}>
                  <div className={styles.departmentName}>{department.departmentName}</div>
                  <div className={styles.departmentDefaultPlan}>
                    {department.defaultPlannedHours > 0 ? (
                      showSpending(department.defaultPlannedSpending, department.defaultPlannedHours)
                    ) : (
                      <PlanrButton
                        size="small"
                        type="lightblueish"
                        style={{ height: "25px", fontSize: "10px" }}
                        onClick={() => {
                          setSelectedDepartment(department.departmentName);
                          setShowSaveDepartment(true);
                          setSaveDefaultPlan(true);
                        }}
                      >
                        Зафиксировать
                      </PlanrButton>
                    )}
                  </div>
                  {/* <div className={styles.departmentTotalPlan}>
                    {showSpending(department.plannedSpending, department.plannedHours)}
                  </div> */}
                  <div className={styles.departmentTodayPlan}>
                    {(department.defaultPlannedSpending >= department.remainingPlannedSpending ||
                      department.defaultPlannedHours <= 0) &&
                      showSpending(department.remainingPlannedSpending, department.remainingPlannedHours)}
                    {department.defaultPlannedSpending < department.remainingPlannedSpending &&
                      department.defaultPlannedHours > 0 && (
                        <div className={styles.remainSum}>
                          <PlanrButton
                            size="small"
                            type="lightdanger"
                            style={{ height: "25px", fontSize: "11px" }}
                            onClick={() => {
                              setSelectedDepartment(department.departmentName);
                              setSaveDefaultPlan(false);
                              setShowSaveDepartment(true);
                            }}
                          >
                            {showSpending(department.remainingPlannedSpending, department.remainingPlannedHours)}
                          </PlanrButton>
                          {department.newDefaultPlanHours > 0 && (
                            <Tooltip
                              content={
                                <div>
                                  <p>{`Отправлен запрос на`}</p>
                                  <p>
                                    {showSpending(department.newDefaultPlanSpending, department.newDefaultPlanHours)}
                                  </p>
                                </div>
                              }
                            >
                              <GeneralIcon
                                type="general-exclamation"
                                style={{ color: "red", marginLeft: "10px" }}
                                // size={20}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <Buttons
            left={
              <div style={{ display: "flex" }}>
                {/* <PlanrButton size="small" type="greenish" onClick={this.saveDevelopers}>
                  Сформировать
                </PlanrButton> */}
                <PlanrButton size="small" type="graybtn" onClick={toggleShowDepartments}>
                  Закрыть
                </PlanrButton>
              </div>
            }
          />
        </div>
      </Dialog>

      <Dialog
        title={`Подтверждение сохранения`}
        isOpen={showSaveDepartment}
        onClose={toggleShowSaveDepartment}
        backdropClassName="standard"
        className={`${styles.infoDialog} figma-dialog`}
      >
        <div className={`${Classes.DIALOG_BODY} `}>
          {selectedOrder && selectedDepartment && (
            <div className={styles.info}>
              {saveDefaultPlan
                ? `Вы действительно хотите сохранить плановые затраты для отдела "${selectedDepartment}" по проекту ${
                    selectedOrder.orderName
                  } на сумму ${
                    selectedDep && formatMoney(selectedDep.remainingPlannedSpending)
                  }? После сохранения вы сможете и дальше редактировать табель план по проекту. Если текущая сумма плановых затрат превысит фиксированную, у вас будет возможность отправить запрос на согласование изменений.`
                : `Вы действительно хотите отправить запрос на изменение фиксированных плановых затрат для отдела "${selectedDepartment}" по проекту ${
                    selectedOrder.orderName
                  } на сумму ${selectedDep && formatMoney(selectedDep.remainingPlannedSpending)}?`}
            </div>
          )}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <Buttons
            left={
              <div style={{ display: "flex" }}>
                <PlanrButton
                  size="small"
                  type="greenish"
                  onClick={async () => {
                    if (selectedOrder) {
                      const res = await saveDefaultDepartmentSpending(
                        selectedDepartment,
                        selectedOrder.orderId,
                        saveDefaultPlan
                      );
                      if (res) toggleShowSaveDepartment();
                    }
                  }}
                >
                  Сохранить
                </PlanrButton>
                <PlanrButton
                  size="small"
                  type="graybtn"
                  onClick={() => {
                    toggleShowSaveDepartment();
                  }}
                >
                  Отмена
                </PlanrButton>
              </div>
            }
          />
        </div>
      </Dialog>

      <div className={`${styles.projectsList_container} ${isExpanded ? styles.projectsList_container_expanded : ""}`}>
        {!canDepartmentOnly ? (
          orders.length > 0 ? (
            <>
              <div className={`${styles.projectsList_head}`}>
                <div className={styles.name}>Проект</div>
                <div className={styles.defaultPlan}>Начальный План</div>
                <div className={styles.todayPlan}>Текущий План</div>
              </div>
              <div className={styles.containerOrders}>
                {orders.map((project) => (
                  <div
                    onDoubleClick={() => {
                      setSelectedOrder(project);
                      toggleShowDepartments();
                    }}
                    key={project.orderId}
                    className={`${styles.projectsList_item}`}
                  >
                    <div className={styles.name}>{project.orderName}</div>
                    <div className={styles.defaultPlan}>
                      {showSpending(project.totalDefaultPlannedSpending, project.totalDefaultPlannedHours)}
                    </div>
                    <div
                      className={styles.todayPlan}
                      style={
                        project.totalDefaultPlannedSpending < project.totalRemainingPlannedSpending &&
                        project.totalDefaultPlannedSpending !== 0
                          ? { color: "#e31818" }
                          : {}
                      }
                    >
                      {showSpending(project.totalRemainingPlannedSpending, project.totalRemainingPlannedHours)}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className={styles.info}>Данные по проектам за период отсутствуют</div>
          )
        ) : departmentData.length > 0 ? (
          <>
            <div className={`${styles.projectsList_head}`}>
              <div className={styles.name}>Проект</div>
              <div className={styles.defaultPlan}>Начальный План</div>
              <div className={styles.todayPlan}>Текущий План</div>
            </div>
            <div className={styles.containerOrders}>
              {departmentData.map((item) => {
                return item != null ? (
                  <div key={item.orderId} className={`${styles.projectsList_dep}`}>
                    <div className={styles.name}>{item.orderName}</div>
                    <div className={styles.defaultPlan}>
                      {item.department.defaultPlannedHours > 0 ? (
                        showSpending(item.department.defaultPlannedSpending, item.department.defaultPlannedHours)
                      ) : (
                        <PlanrButton
                          size="small"
                          type="lightblueish"
                          style={{ height: "25px", fontSize: "10px" }}
                          onClick={() => {
                            setSelectedDepartment(departments[0]);
                            setSelectedOrder(orders.find((o) => o.orderId === item.orderId));
                            setShowSaveDepartment(true);
                            setSaveDefaultPlan(true);
                          }}
                        >
                          Зафиксировать
                        </PlanrButton>
                      )}
                    </div>
                    <div className={styles.todayPlan}>
                      {(item.department.defaultPlannedSpending >= item.department.remainingPlannedSpending ||
                        item.department.defaultPlannedHours <= 0) &&
                        showSpending(item.department.remainingPlannedSpending, item.department.remainingPlannedHours)}
                      {item.department.defaultPlannedSpending < item.department.remainingPlannedSpending &&
                        item.department.defaultPlannedHours > 0 && (
                          <div className={styles.remainSum}>
                            <PlanrButton
                              size="small"
                              type="lightdanger"
                              style={{ height: "25px", fontSize: "11px" }}
                              onClick={() => {
                                setSelectedDepartment(departments[0]);
                                setSelectedOrder(orders.find((o) => o.orderId === item.orderId));
                                setSaveDefaultPlan(false);
                                setShowSaveDepartment(true);
                              }}
                            >
                              {showSpending(
                                item.department.remainingPlannedSpending,
                                item.department.remainingPlannedHours
                              )}
                            </PlanrButton>
                            {item.department.newDefaultPlanHours > 0 && (
                              <Tooltip
                                content={
                                  <div>
                                    <p>{`Отправлен запрос на`}</p>
                                    <p>
                                      {showSpending(
                                        item.department.newDefaultPlanSpending,
                                        item.department.newDefaultPlanHours
                                      )}
                                    </p>
                                  </div>
                                }
                              >
                                <GeneralIcon type="general-exclamation" style={{ color: "red", marginLeft: "10px" }} />
                              </Tooltip>
                            )}
                          </div>
                        )}
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          </>
        ) : (
          <div className={styles.info}>Данные по отделу за период отсутствуют</div>
        )}
      </div>
      <div className={styles.projectsList_container_btn}>
        {orders.length > 1 && (
          <PlanrButton
            type="secondary"
            onClick={() => setIsExpanded(!isExpanded)}
            size="small"
            style={{ width: "120px" }}
          >
            {isExpanded ? "Свернуть" : "Развернуть"}
          </PlanrButton>
        )}
      </div>
    </div>
  );
});
